import Container from 'common/components/UI/Container';
import BlogPostBannerWrapper, { BannerContent } from './banner.style';

export interface BlogPostBannerProps {
  title?: string;
  subtitle?: string;
  bannerImg?: string;
  bannerImgMobile?: string;
}

// Banner content is currently disabled — the parent renders the post body
// directly. Kept as a placeholder so the route layout matches PagesBanner.
const BlogPostBanner = (_props: BlogPostBannerProps) => (
  <BlogPostBannerWrapper id="home">
    <Container>
      <BannerContent />
    </Container>
  </BlogPostBannerWrapper>
);

export default BlogPostBanner;
